import React, { useEffect, useRef, useState } from "react";
import "./HoppersCafeMenu.scss"
import heroBackground from "../../assets/cafeHero.jpg"
import bottomBackground from "../../assets/cafeBottom.jpg"

import MenuLayout from "../../components/MenuLayout/MenuLayout";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";


const HoppersCafeMenu = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "cafeMenu")
    const Components = page?.Components || []
    const dispatch = useDispatch()
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);


    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "HoppersCafeMenu-Hero-header":
                return <div className="HoppersCafeMenu-Hero-header">
                    {component?.Props?.text}
                </div>
            case "HoppersCafeMenu-Hero-subheader":
                return <div className="HoppersCafeMenu-Hero-subheader">
                    {component?.Props?.text1}<br />
                    {component?.Props?.text2}
                </div>
            case "HoppersCafeMenu-Hero-cont":
                return <div className="HoppersCafeMenu-Hero-cont">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="HoppersCafeMenu-Hero"
                style={{
                    backgroundImage: `linear-gradient(#00000099,#00000099), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getMenuComponent = (component) => {
        switch (component.ID) {
            case "HoppersCafeMenu-Container-header":
                return <div className="HoppersCafeMenu-Container-header">
                    {component?.Props?.text}
                </div>
            case "HoppersCafeMenu-Container-subheader":
                return <div className="HoppersCafeMenu-Container-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersCafeMenu-Container-grid":
                return <div className="HoppersCafeMenu-Container-grid">
                    {component?.Data.map((data, key) => {
                        return (
                            <MenuLayout
                                key={key}
                                data={data}
                                isMenu />
                        )
                    })}
                </div>
            case "HoppersCafeMenu-Container-btn":
                return <div className="HoppersCafeMenu-Container-btn">
                    <Button
                        text={component?.Props?.btnText}
                        width={"max-content"}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getMenuContent = (components) => {
        return (
            <div className="HoppersCafeMenu-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getMenuComponent(component)
                    )
                })}
            </div>
        )
    }
    const getBookComponent = (component) => {
        switch (component.ID) {
            case "HoppersCafeMenu-bottom-header":
                return <div className="HoppersCafeMenu-bottom-header">
                    {component?.Props?.text}
                </div>
            case "HoppersCafeMenu-bottom-subheader":
                return <div className="HoppersCafeMenu-bottom-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersCafeMenu-bottom-btn":
                return <div className="HoppersCafeMenu-bottom-btn">
                    <Button
                        text={component?.Props?.btnText}
                        width={component?.Props?.width}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    const getBookContent = (components, bottomBackground) => {
        return (
            <div className="HoppersCafeMenu-bottom"
                style={{
                    backgroundImage: `linear-gradient(#000000B2,#000000B2), url(${bottomBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (<div key={key}>
                        {getBookComponent(component)}
                    </div>)
                })}
            </div>
        )
    }
    const getImagesCarousel = (data) => {
        return (
            <div className="HoppersCafeMenu-ImageCarousel" ref={containerRef}>
                <div className="HoppersCafeMenu-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="HoppersCafeMenu-Cont-image" />
                    ))}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCafeMenu-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "HoppersCafeMenu-Container":
                return getMenuContent(component.Components)
            case "HoppersCafeMenu-bottom":
                return getBookContent(component.Components, component?.Props?.bgSrc)
            case "HoppersCafeMenu-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCafeMenu">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div >
    )
}
export default HoppersCafeMenu